import React, { useEffect } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import {
	SlIcon,
	useIcons,
	close,
	sololearnRound,
	appStoreBadge,
	playStoreBadge,
} from '@sololearnorg/icons';

import { LocalizedLink } from '../LocalizedLink/LocalizedLink';

import s from './SlNotAllowedFeature.scss';

interface ISlNotAllowedFeature {
    os: string;
    onCloseClick: () => void;
    onMobileStoreClick?: () => void;
}

export const SlNotAllowedFeature: React.FC<ISlNotAllowedFeature> = React.memo(
	({ os, onCloseClick, onMobileStoreClick }) => {
		useStyles(s);
		useIcons([close, sololearnRound, appStoreBadge, playStoreBadge]);

		useEffect(() => {
			document.body.style.overflow = 'hidden';
			return () => {
				document.body.style.overflow = 'auto';
			};
		}, []);

		const handleMobileStoreClick = () => {
			onMobileStoreClick?.();
		};

		return (
			<div className="sl-not-allowed">
				<div onClick={onCloseClick} className="sl-not-allowed__close">
					<SlIcon iconId="close" />
				</div>
				<div className="sl-not-allowed__content">
					<div className="sl-not-allowed__logo">
						<SlIcon iconId="sololearnRound" />
					</div>
					<h1 className="sl-not-allowed__title">
						Practice makes
						<br />
						perfect.
					</h1>
					<p className="sl-not-allowed__info">
						Some features are only available in our
						<br />
						Desktop and Mobile versions.
					</p>
					{os && (
						<div
							className="sl-not-allowed__link"
							onClick={handleMobileStoreClick}
						>
							{os === 'iOS' && (
								<LocalizedLink
									to="https://itunes.apple.com/us/app/apple-store/id1210079064?mt=8"
									target="_blank"
								>
									<SlIcon iconId="appStoreBadge" />
								</LocalizedLink>
							)}
							{os === 'Android' && (
								<LocalizedLink
									to="https://play.google.com/store/apps/details?id=com.sololearn"
									target="_blank"
								>
									<SlIcon iconId="playStoreBadge" />
								</LocalizedLink>
							)}
						</div>
					)}
				</div>
			</div>
		);
	},
);
